import { DesignComponentOrigin, } from "../support/SDKDesignComponentOrigin";
export class Asset {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model, duplicates, sources) {
        var _a, _b, _c, _d;
        this.id = model.persistentId;
        this.brandId = model.brandId;
        this.designSystemVersionId = model.designSystemVersionId;
        this.thumbnailUrl = (_a = model.thumbnailUrl) !== null && _a !== void 0 ? _a : null;
        this.svgUrl = (_b = model.svgUrl) !== null && _b !== void 0 ? _b : null;
        this.thumbnailUrl = (_c = model.thumbnailUrl) !== null && _c !== void 0 ? _c : null;
        this.previouslyDuplicatedNames = duplicates;
        this.name = model.meta.name;
        this.description = (_d = model.meta.description) !== null && _d !== void 0 ? _d : null;
        this.componentId = model.id;
        this.origin = model.originComponent
            ? new DesignComponentOrigin(model.originComponent, sources)
            : null;
        this.createdAt = model.createdAt ? new Date(model.createdAt) : null;
        this.updatedAt = model.updatedAt ? new Date(model.updatedAt) : null;
        this.isAsset = model.exportProperties.isAsset;
    }
    /** Constructs representation that can be used to transport the instantiated object as JSON */
    toTransport() {
        return {
            id: this.id,
            brandId: this.brandId,
            designSystemVersionId: this.designSystemVersionId,
            thumbnailUrl: this.thumbnailUrl,
            svgUrl: this.svgUrl,
            name: this.name,
            // @ts-expect-error TS(2531): Object is possibly 'null'.
            description: this.description,
            componentId: this.componentId,
            previouslyDuplicatedNames: this.previouslyDuplicatedNames,
            origin: this.origin, // Assuming DesignComponentOrigin is already serializable
            createdAt: this.createdAt ? this.createdAt.toISOString() : "",
            updatedAt: this.updatedAt ? this.updatedAt.toISOString() : "",
            exportProperties: {
                isAsset: this.isAsset,
            },
        };
    }
    /** Reconstructs class from the transport model */
    static fromTransport(model) {
        var _a, _b, _c;
        // const origin = model.origin
        //   ? DesignComponentOrigin.fromTransport(model.origin)
        //   : null
        const fakeDesignComponentRemoteModel = {
            persistentId: model.id,
            brandId: model.brandId,
            designSystemVersionId: model.designSystemVersionId,
            thumbnailUrl: (_a = model.thumbnailUrl) !== null && _a !== void 0 ? _a : undefined,
            svgUrl: (_b = model.svgUrl) !== null && _b !== void 0 ? _b : undefined,
            meta: {
                name: model.name,
                description: model.description,
            },
            id: (_c = model.componentId) !== null && _c !== void 0 ? _c : "",
            parsedOriginComponent: model.origin
                ? DesignComponentOrigin.fromTransport(model.origin)
                : undefined,
            // @ts-expect-error TS(2322): Type 'string' is not assignable to type 'Date'.
            createdAt: model.createdAt,
            // @ts-expect-error TS(2322): Type 'string' is not assignable to type 'Date'.
            updatedAt: model.updatedAt,
            exportProperties: {
                isAsset: model.exportProperties.isAsset,
            },
            properties: [],
        };
        return new Asset(fakeDesignComponentRemoteModel, model.previouslyDuplicatedNames, []);
    }
}
